<template>
  <div class="category">
    <!-- bhhb {{JSON.stringify(categoriesTree[0])}} -->
    <!-- {{categoryTreeList.name}} -->
    <div>
      <div class="sub_heading" v-if="categoryTreeList.name && categoryTreeList.childCategories && categoryTreeList.childCategories.length">
        <h4>{{ categoryTreeList.name }}</h4>
        <span
          class="see_all"
          @click="categoryListId(categoryTreeList.id, categoryTreeList.name, categoryTreeList.id)" style="color:#fff;background: red;
    padding: 4px 20px;
    white-space: nowrap;
    border-radius: 5px; width: auto;margin-left: 8px;"
          >{{ $t("seeAll") }}</span
        >
      </div>
      <div class="product_list">
        <!-- {{product.chil}} -->
        <div
          class="category_card"
          v-for="(item, index) in categoryTreeList.childCategories"
          :key="index"
          @click="categoryProductById(item.id, categoryTreeList.id)"
        >
          <figure
            class="img_wrapper spinner_wrapper"
            v-lazyload
            v-if="item.bgImageURL"
          >
            <ImageSpinner class="image_spinner" />
            <img :data-url="item.bgImageURL" alt="item" />
          </figure>
          <h3>{{ item.name }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageSpinner from "../Common/ImageSpinner";
export default {
  name: "LifeStyleCategoryCard",
  components: {
    ImageSpinner,
  },
  props: {
    categoriesName: {
    //   type: Array,
    },
    underPriceData: {
      type: Array,
    },
  },
  watch: {
    categoriesName() {
      this.categoryTreeList = this.categoriesName;
    },
  },
  data() {
    return {
      categoryTreeList: [],
    };
  },
  methods: {
    categoryListId(id, name, parentCatId) {
      if(this.$route.query.typeOfSource && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier){
          this.$router.push("/subcategory-listing/" + id + "?subCategoryname=" + name + '&parentCatId=' + parentCatId +'&shopid=' + this.$route.query.shopid + '&source='+this.$route.query.typeOfSource + '&campaignIdentifier=' + this.$route.query.campaignIdentifier + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier + '&from=LIFESTYLE');
        }else if(this.$route.query.typeOfSource && this.$route.query.campaignIdentifier){
          this.$router.push("/subcategory-listing/" + id + "?subCategoryname=" + name + '&parentCatId=' + parentCatId +'&shopid=' + this.$route.query.shopid + '&source='+this.$route.query.typeOfSource + '&campaignIdentifier=' + this.$route.query.campaignIdentifier + '&from=LIFESTYLE');
        }if(this.$route.query.typeOfSource && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier){
          this.$router.push("/subcategory-listing/" + id + "?subCategoryname=" + name + '&parentCatId=' + parentCatId +'&shopid=' + this.$route.query.shopid + '&source='+this.$route.query.typeOfSource + '&campaignIdentifier=' + this.$route.query.campaignIdentifier + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier + '&from=LIFESTYLE');
        }else if(this.$route.query.shopid){
        this.$router.push(
        "/subcategory-listing/" + id + "?subCategoryname=" + name + '&parentCatId=' + parentCatId +'&shopid=' + this.$route.query.shopid + '&from=LIFESTYLE' );
      }else{
         this.$router.push(
        "/subcategory-listing/" + id + "?subCategoryname=" + name + '&parentCatId=' + parentCatId + '&from=LIFESTYLE'
      );
      }
    },
    categoryProductById(categoryId, parentCatId) {
      if(this.$route.name === 'RetailShopItemList'){
        if(this.$route.query.typeOfSource && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier){
          this.$router.push('/product-by-category?type=' + this.$route.query.source + '&categoryid=' + categoryId + '&parentCatId=' + categoryId + '&shopid=' + this.$route.query.shopid + '&source='+this.$route.query.typeOfSource + '&campaignIdentifier=' + this.$route.query.campaignIdentifier + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier + '&from=LIFESTYLE');
        }else if(this.$route.query.typeOfSource && this.$route.query.campaignIdentifier){
          this.$router.push('/product-by-category?type=' + this.$route.query.source + '&categoryid=' + categoryId + '&parentCatId=' + categoryId + '&shopid=' + this.$route.query.shopid + '&source='+this.$route.query.typeOfSource + '&campaignIdentifier=' + this.$route.query.campaignIdentifier + '&from=LIFESTYLE');
        }else if(this.$route.query.shopid){
          this.$router.push('/product-by-category?type=' + this.$route.query.source + '&categoryid=' + categoryId + '&parentCatId=' + categoryId + '&shopid=' + this.$route.query.shopid + '&from=LIFESTYLE');
        }else{
          this.$router.push('/product-by-category?type=' + this.$route.query.source + '&categoryid=' + categoryId + '&parentCatId=' + categoryId + '&from=LIFESTYLE')
        }
       this.$store.commit("saveCategoryFilterData", {
        catfilterProdList: {}
      });
      this.$store.commit("saveCategoriesData", {
        categoriesProdList: [],
        categoriesPageIndex: 0
      });
      }
    },
  },
  mounted() {
    this.categoryTreeList = this.categoriesName;
  },
};
</script>
